<template>
	<div class="callthepolice">
		<div class="callthepolice-T">
			<div class="callthepoliceL">
				<Breadcrumb></Breadcrumb>
				<div class="RightsManagement-searchs">
					<div class="RightsManagement-searchs1">
						<el-date-picker v-model="TimeData" type="datetimerange" @change="TimeChang" range-separator="至"
							style="width: 360px;" :picker-options="pickerOptions1" :clearable="false"
							value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
						<el-select v-model="pages.T_handle" @change="selectChang" style="margin: 0 20px;width: 100px;"
							placeholder="请选择查询条件">
							<el-option label="默认" value="1"></el-option>
							<el-option label="全部记录" value="2"></el-option>
							<el-option label="未处理" value="3"></el-option>
						</el-select>
            <!--  新增查询分类 -->
            <el-select v-model="pages.T_calssid" @change="handleCategoryChange"
                       placeholder="所有分类"
                       style="width: 150px; margin: 0 10px;">
              <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
            <!--  新增查询分类 -->
					</div>
					<div class="callthepoliceit-mai1-btn">
						<el-button type="primary" icon="el-icon-search" @click="showhistory">更多查询</el-button>
					</div>
				</div>
			</div>
			<div class="callthepoliceR">
				<div class="RightsManagement-searchsMai">
					<el-button v-permission="'Device:Warning:Excel'" type="warning"
						@click="DowDataExcel">导出Excel</el-button>
					<!-- <el-button type="danger" icon="el-icon-plus" @click="clickNew()">新增</el-button> -->
				</div>
			</div>
		</div>
		<div class="callthepolice-B">
			<el-table ref="multipleTable" v-loading="loading" :data="tableData" border size="mini"
				:row-class-name="tableRowClassName" @selection-change="handleSelectionChange">
				<template slot="empty">
					<noData></noData>
				</template>
				<el-table-column type="selection" width="55">
				</el-table-column>
				<el-table-column label="类型" width="120">
					<template slot-scope="scope" show-overflow-tooltip>{{ scope.row.T_tp_name }}</template>
				</el-table-column>
				<el-table-column prop="T_sn" label="SN" width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="T_DS_name" label="名称" width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="T_Ut" label="报警开始时间 " width="150" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="T_Text" label="处理措施" width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column prop="T_Text" label="处理凭证" width="100">
					<template slot-scope="scope">
						<el-image style="width:30px; height: 25px"
							v-if="scope.row.T_attachments && scope.row.T_attachments.length > 0"
							:src="scope.row.T_attachments[0].url" fit="cover"
							:preview-src-list="scope.row.T_attachments.map(item => item.url)">
						</el-image>
					</template>
				</el-table-column>
				<el-table-column prop="T_handler" label="处理人" width="100" show-overflow-tooltip>
				</el-table-column>
				<el-table-column v-if="hides" label="报警处理时间 " width="150" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ scope.row.T_State == 2 ? scope.row.UpdateTime : '-' }}
					</template>
				</el-table-column>

				<el-table-column prop="T_Remark" label="内容" show-overflow-tooltip>
				</el-table-column>

				<el-table-column label="操作" width="250" fixed="right">
					<template slot-scope="scope">
						<el-button v-permission="'Device:Warning:Handle'" size="small"
							@click="SetChuli(scope.row)">处理</el-button>
						<el-button v-permission="'Device:Warning:Record'" size="small"
							@click="Setjilu(scope.row)">记录</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-button v-permission="'Device:Warning:DatchHandle'" @click="ResDateFilter"
				style="margin-top: 10px;">批量处理</el-button>
			<div style="margin-top: 50px;">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
					:current-page="pages.page" :page-size="pages.page_z" :page-sizes="[10, 50, 100, 500, 1000]"
					layout="total, sizes, prev, pager, next, jumper" :total="total">
				</el-pagination>
			</div>
		</div>
		<el-drawer title="更多查询" :visible.sync="drawer" direction="rtl" size="50%" :append-to-body="true">
			<div style="padding:0 20px;">
				<el-form ref="form" :model="pages" label-width="80px">
					<!-- <el-form-item label="查询条件">
						<el-select v-model="pages.T_history" @change="selectChang" placeholder="请选择查询条件">
							<el-option label="最近40天" value="0"></el-option>
							<el-option label="历史记录" value="1"></el-option>
						</el-select>
					</el-form-item> -->
					<!-- <el-form-item :label="pages.T_history == 0 ? '最近40天' : '历史记录'">
						<el-date-picker v-model="TimeData" type="datetimerange" @change="TimeChang" range-separator="至"
							:picker-options="pages.T_history == 0 ? pickerOptions : pickerOptions1"
							value-format="yyyy-MM-dd HH:mm:ss" start-placeholder="开始日期" end-placeholder="结束日期">
						</el-date-picker>
					</el-form-item> -->
					<el-form-item label="名称查询">
						<inputs @inputs="inputValue" :inputShow="true" inputPlace="请输入名称"></inputs>
					</el-form-item>
					<el-form-item label="报警分类">
						<el-checkbox :indeterminate="isIndeterminate" v-model="checkAll"
							@change="handleCheckAllChange">全选</el-checkbox>
						<el-checkbox-group v-model="pages.T_tp" @change="handleCheckedCitiesChange">
							<el-checkbox v-for="item, index in dataPowerAll" :label="item.Id" :key="index">{{
								item.T_name }}
							</el-checkbox>
						</el-checkbox-group>
					</el-form-item>
					<!-- <el-form-item label="状态查询">
						<el-radio-group v-model="pages.T_handle">
							<el-radio label="1">默认</el-radio>
							<el-radio label="2">全部记录</el-radio>
							<el-radio label="3">未处理</el-radio>
						</el-radio-group>
					</el-form-item> -->
					<el-form-item>
						<el-button type="primary" @click="onSubmit">立即搜索</el-button>
						<el-button @click="drawer = false">取消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-drawer>
		<el-drawer title="处理记录" :visible.sync="drawerJiLu" direction="rtl" size="50%" :append-to-body="true">
			<div style="padding:0 20px;">
				<el-table ref="singleTable" :data="tableData1" highlight-current-row style="width: 100%">
					<template slot="empty">
						<noData></noData>
					</template>
					<el-table-column type="index" width="50" label="序号">
					</el-table-column>
					<el-table-column label="详细信息">
						<template slot-scope="scope">
							{{ scope.row }}
						</template>
					</el-table-column>
				</el-table>
			</div>
		</el-drawer>
		<el-dialog title="处理" :visible.sync="dialogChuli" width="800px" :append-to-body="true" destroy-on-close>
			<el-form ref="chuliPage" :model="chuliPage" label-width="100px" label-position="top">
				<el-form-item label="处理报警备注">
					<el-input v-model="chuliPage.T_Text"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" size="mini" @click="chuliPage.T_Text = '更换探头'">更换探头</el-button>
          <el-button type="primary" size="mini" @click="chuliPage.T_Text = '传感器报警测试'">传感器报警测试</el-button>
					<el-button type="primary" size="mini" @click="chuliPage.T_Text = '验证测试，合理超温，无措施'">验证测试，合理超温，无措施</el-button>
					<el-button type="primary" size="mini" @click="chuliPage.T_Text = '来货陈列，完成后立即关柜门'">来货陈列，完成后立即关柜门</el-button>
          <el-button type="primary" size="mini" @click="chuliPage.T_Text = '送药完，忘关监控'">送药完，忘关监控</el-button>
					<el-button type="primary" size="mini" @click="chuliPage.T_Text = '药品盘点，完成后立即关柜门'">药品盘点，完成后立即关柜门</el-button>
				</el-form-item>
				<el-form-item label="处理凭证（最多上传3张）">
					<el-upload list-type="picture-card" :limit="limit" multiple action="#" :on-remove="handleRemove"
						:http-request="uploadToQiniu" :on-preview="handlePictureCardPreview" :file-list="uploadList">
						<i class="el-icon-plus"></i>
					</el-upload>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogChuli = false">取 消</el-button>
				<el-button type="primary" @click='onSubmitFun'>确 定</el-button>
			</span>
		</el-dialog>
		<!-- 图片预览对话框 -->
		<el-dialog :visible.sync="dialogImageVisible" title="图片预览" width="max-content" append-to-body>
			<img :src="dialogImageUrl" alt="预览图片" style="max-height: 60vh;max-width: 100vw;" />
		</el-dialog>
	</div>
</template>

<script>
import {
	WarningList,
	WTall,
	DevicEdit,
	DevicDel,
	DevicExcel
} from "@/api/Warning.js"
import Axios from 'axios'
import fileDownload from 'js-file-download';
import { formatDate } from '../../utils/Times.js'

import { PDFToken } from "@/api/pdfToken.js";
import * as qiniu from "qiniu-js";
import {
  ClassList,
  DevSenList
} from '../../api/dataDisplay/realtime.js'

export default {
	data() {
		return {
			limit: 3, //上传文件数量限制
			uploadTokens: {}, // 存储上传token的对象
			uploadFileList: [],// 上传文件列表
			dialogImageVisible: false, // 图片预览对话框是否可见
			dialogImageUrl: '', // 图片预览对话框中的图片URL
			uploadList: [],// 上传文件列表

			showChu: '',
			chuliPage: {
				T_id: '',
				T_Text: '',
				T_time: '',
				T_history: '',
				T_attachments: ''
			},
			dialogChuli: false,
			checkAll: true,
			isIndeterminate: false,
			Excelobj: {},
			loading: true,
			TimeData: [],
			dataPowerAll: [], //报警选择
      options: [{ value: 0, label: '所有分类' }], // 新增：存储分类列表  新增查询分类
			pages: {
        T_calssid: 0, // 新增：分类 ID  新增查询分类
				T_name: '',
				T_tp: [],
				T_handle: '1', //1 默认 2 全部记录 3未处理
				Time_start: '',
				Time_end: '',
				T_admin: 0,
				T_history: '0', //0 40天 1 历史数据
				page: 1,
				page_z: 10,
			},
			total: 0,
			pages1: {//表格数据
				T_snid: '',
				Time_start: '',
				Time_end: '',
				page: 1,
				page_z: 10,
			},
			pickerOptions1: {//选择当前时间的前后6个月
				onPick: ({
					maxDate,
					minDate
				}) => {
					this.beginDate = minDate && minDate.getTime();
					if (maxDate) {
						this.endDate = "";
					}
				},
				disabledDate: (time) => {
					const minTime = new Date(this.beginDate).setMonth(
						new Date(this.beginDate).getMonth() - 6
					);
					const maxTime = new Date(this.beginDate).setMonth(
						new Date(this.beginDate).getMonth() + 6
					);
					return this.beginDate
						? time.getTime() < minTime || time.getTime() > maxTime
						: false;
				},
			},
			// pickerOptions1: {
			// 	onPick: ({
			// 		maxDate,
			// 		minDate
			// 	}) => {
			// 		this.pickerMinDate = minDate.getTime()
			// 		if (maxDate) {
			// 			this.pickerMinDate = ''
			// 		}
			// 	},
			// 	disabledDate: (time) => {
			// 		if (this.pickerMinDate !== '') {
			// 			if (this.pickerMinDate !== undefined) { //不为und时证明选择,则显示为可选择
			// 				var y = new Date(this.pickerMinDate).getFullYear()
			// 				var m = new Date(this.pickerMinDate).getMonth() + 1
			// 				var d = new Date(y, m, 0).getDate(); //获取当前选中月最后一日
			// 				var minTm = new Date(y + '-' + m + '-01 00:00:00').getTime() //可选的最小范围
			// 				var maxTm = new Date(y + '-' + m + '-' + d + ' 00:00:00').getTime() //可选的最大范围
			// 				return time.getTime() < minTm || time.getTime() > maxTm
			// 			} else { //为und时证明没有选择,则显示为可选择
			// 				const one = 30 * 24 * 3600 * 1000
			// 				const minTime = this.pickerMinDate - one
			// 				const maxTime = this.pickerMinDate + one
			// 				return time.getTime() < minTime || time.getTime() > maxTime
			// 			}
			// 		}
			// 	}
			// },
			pickerOptions: {
				disabledDate(time) {
					let AtTime = new Date().getTime(); //获取此时的时间戳
					return (
						time.getTime() < AtTime - (86400000 * 40) //小于当前时间40天的全部disabled掉
						||
						time.getTime() > AtTime //大于当前时间的全部disabled掉
					);
				}
			},
			drawer: false,
			drawerJiLu: false, //记录弹窗
			tableData: [],
			tableData1: [],
			multipleSelection: [],
			dialogVisible: false,
			hides: null,
		}
	},
	mounted() {
		this.pages = { ...this.pages, ...this.$route.query }
		console.log(this.pages)
		this.setTimefn()
		this.getWarningListApi()
		this.shouldShowAlarmColumn()

    this.GetClassListApi()
	},
	methods: {
    //  新增查询分类
    handleCategoryChange() {
      this.pages.page = 1 // 重置页码
      this.getWarningListApi() // 自动查询
    },
    GetClassListApi() { // 新增查询分类
      var that = this
      ClassList({}).then(res => {
        if (res.data.Code === 200 && res.data.Msg === 'ok!') {
          var Arr = res.data.Data.Data
          if (Arr != null) {
            // 清空防止重复
            that.options = []
            Arr.forEach(function (item) {
              that.options.push({
                value: item.Id,
                label: item.T_name
              })
            })
            // 头部插入“所有分类”，value 为 '' 以便默认选中
            that.options.unshift({
              value: 0,
              label: '所有分类'
            })
          }
        }
      })
    },
    //  新增查询分类

		// 预览图片
		handlePictureCardPreview(file) {
			// 这里需要根据您的实际情况设置正确的图片URL
			// 注意：您目前存储的只是key，需要拼接成完整的URL
			// 请替换YOUR_QINIU_DOMAIN为您的七牛云域名
			this.dialogImageUrl = file.url;
			this.dialogImageVisible = true;
		},
		//删除附件
		handleRemove(file) {
			let arr = [...this.uploadFileList]
			const newList = arr.filter(item => item.name !== file.name);
			this.uploadFileList = newList;
		},
		// 上传到七牛云
		async uploadToQiniu(options) {
			const { file, onSuccess, onError, onProgress } = options;
			try {
				// 获取上传token
				const token = await this.getUploadToken(file);
				// 生成唯一的文件名
				const timestamp = new Date().getTime();
				const suffix = file.name.substring(file.name.lastIndexOf('.'));
				const key = `file/${timestamp}${suffix}`;

				// 七牛云上传配置 - 根据项目实际情况调整
				const config = {
					useCdnDomain: true, // 表示是否使用cdn加速域名
					region: qiniu.region.z2, // 华南区域 - 根据错误提示设置为z2，对应up-z2.qiniup.com
					chunkSize: 4 * 1024 * 1024, // 4MB分片大小
					forceDirect: false // 断点续传方式
				};


				const putExtra = {
					fname: file.name, //文件原始文件名
					params: {},
					mimeType: [] || null // 自动检测MIME类型
				};

				// 执行上传
				const observable = qiniu.upload(file, key, token, putExtra, config);

				observable.subscribe({
					next: (res) => {
						// 上传进度
						onProgress({ percent: res.total.percent });
					},
					error: (err) => {
						onError(err);
						this.$message.error('上传失败：' + err.message);
					},
					complete: (res) => {
						// 上传成功
						onSuccess(res);
						// 上传成功后，将文件信息添加到列表
						this.uploadFileList.push({
							name: file.name,
							url: res.key, // 假设返回的url是完整的url
							size: file.size,
						});
					}
				});
			} catch (error) {
				onError(error);
			}
		},
		// 获取上传token
		async getUploadToken(file) {
			try {
				const suffix = file.name.substring(file.name.lastIndexOf('.') + 1).toLowerCase();
				const response = await PDFToken({
					T_suffix: suffix
				});
				// 检查响应状态，根据http.js中的逻辑，应该检查response.data.Code
				if (response && response.data && (response.data.Code === 200 || response.data.Code === 220)) {
					// 存储token，使用文件名作为key
					this.uploadTokens[file.name] = response.data.Data;
					return response.data.Data;
				} else {
					const errorMsg = response && response.data && response.data.Msg ? response.data.Msg : '获取上传凭证失败';
					throw new Error(errorMsg);
				}
			} catch (error) {
				this.$message.error('获取上传凭证失败：' + error.message);
				throw error;
			}
		},
		shouldShowAlarmColumn() {
			const setPid = localStorage.getItem('setPid');
			Axios.get('https://cold.coldbaozhida.com/JsonHttp.json').then(res => {
				console.log('res', res, setPid)
				const arr = res.data;
				this.hides = !arr.includes(Number(setPid))
			});
		},
		setTimefn() { //获取当天0点与当前时间
			const now = new Date();
			const midnight = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
			const min = midnight.getTime() - (86400000 * 40)//今天0点时间戳，
			const max = now.getTime(); //当前时间戳
			this.pages.Time_start = formatDate(min)
			this.pages.Time_end = formatDate(max)
			this.TimeData = [formatDate(min), formatDate(max)]
			this.$emit("pick", this.TimeData)
		},
		showhistory() {
			this.drawer = true
			this.SetWarning()
		},
		handleCheckAllChange(e) {
			e ? this.dataPowerAll.forEach(item => { this.pages.T_tp.push(item.Id) }) : this.pages.T_tp = []
			this.isIndeterminate = false;//全选状态
		},
		handleCheckedCitiesChange(value) {
			////console.log('danxuan', value)
			let checkedCount = value.length;
			this.checkAll = checkedCount === this.dataPowerAll.length;
			this.isIndeterminate = checkedCount > 0 && checkedCount < this.dataPowerAll.length;
		},
		DowDataExcel() {
			if (this.tableData == null) {
				this.$message.error('当前导出没有数据哦！')
				return
			} else {
				const loading = this.$loading({
					lock: true,
					text: '正在整理数据，请稍后...',
					spinner: 'el-icon-loading',
					background: 'rgba(0, 0, 0, 0.7)'
				});
				DevicExcel(this.Excelobj).then(res => {
					////console.log('导出exc', res)
					loading.close()
					Axios({
						method: 'get',
						url: res.data.Data,
						responseType: 'blob'
					}).then(resBlob => {
						fileDownload(resBlob.data, `${new Date().getTime()}.xlsx`);
					});
				})
			}
		},
		tableRowClassName({ row, rowIndex }) {
			////console.log('表格', row, rowIndex)
			if (row.T_State === 3) {
				return 'warning-row';
			} else {
				return '';
			}

		},
		async SetWarning() {
			var pwAll = await this.GetWTallApi()
			if (pwAll.data.Code === 200) {
				this.checkAll = true;//全选状态
				this.isIndeterminate = false
				var arr = pwAll.data.Data
				this.pages.T_tp = []
				this.dataPowerAll = arr
				arr.forEach(item => {
					this.pages.T_tp.push(item.Id)
				})
				////console.log('48888', this.checkAll)
			}
		},
		GetWTallApi() { //获取报警权限
			return new Promise(resolve => {
				WTall({}).then(res => {
					resolve(res)
				})
			})
		},
		getWarningListApi() {
			this.loading = true
			var obj = { ...this.pages }
			console.log('obj', obj)
			obj.T_tp.length != 0 ? obj.T_tp = "T" + obj.T_tp.join('|T') + "|" : obj.T_tp = ''
			this.Excelobj = obj
			return new Promise(resolve => {
				WarningList(obj).then(res => {
					if (res.data.Code === 200) {
						this.loading = false
						this.total = res.data.Data.Num
						this.tableData = res.data.Data.Data
						resolve(res.data)
					}
				})
			})
		},

		Setjilu(e) { //记录
			////console.log(e)
			this.tableData1 = e.T_Log
			this.drawerJiLu = true
		},
		SetDel(obj) { //删除
			////console.log('删除', obj)
			this.$confirm('此操作将执行删除, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
				center: true
			}).then(() => {
				DevicDel({
					T_id: obj.Id,
					T_time: obj.T_Ut,
					T_history: obj.T_history
				}).then(res => {
					if (res.data.Code === 200) {
						this.getWarningListApi()
						this.$message.success('操作成功，已删除')
					}
				})
			}).catch(() => {
				this.$message({
					type: 'info',
					message: '已取消删除'
				});
			});
		},
		SetChuli(e) { //处理按钮
			this.chuliPage = {
				T_id: e.Id,
				T_Text: '',
				T_time: e.T_Ut,
				T_history: e.T_history,
				T_attachments: ''
			}
			this.uploadFileList = []
			this.uploadList = []
			this.showChu = 'rad'
			this.dialogChuli = true
		},
		onSubmitFun() {
			if (this.showChu == 'all') {
				this.asyncPro()
			} else {
				this.subChuli()
			}
		},
		async subChuli() {
			let arr = JSON.parse(JSON.stringify(this.uploadFileList))
			this.chuliPage.T_attachments = JSON.stringify(arr)

			var val = await this.setDevicEditApi(this.chuliPage)
			if (val.data.Code == 200) {
				this.pages.page = 1
				this.getWarningListApi()
				this.$message.success('处理成功');
				this.dialogChuli = false
				this.chuliPage.T_Text = ''
			}
		},
		ResDateFilter() { //批量处理
			if (this.multipleSelection.length == 0) {
				this.$message.error('请选择至少一项')
			} else {
				this.showChu = 'all'
				this.uploadFileList = []
				this.uploadList = []
				this.dialogChuli = true
			}

		},
		async asyncPro() {
			let arr = JSON.parse(JSON.stringify(this.uploadFileList))
			this.chuliPage.T_attachments = JSON.stringify(arr)

			var obj = {
				T_id: null,
				T_Text: this.chuliPage.T_Text,
				T_attachments: this.chuliPage.T_attachments
			}

			var k = 0
			for (let i = 0; i < this.multipleSelection.length; i++) {
				obj.T_id = this.multipleSelection[i].Id
				obj.T_time = this.multipleSelection[i].T_Ut
				obj.T_history = this.pages.T_history

				console.log('批量处理---' + i, obj)
				let objs = await this.setDevicEditApi(obj);
				if (objs) {
					k = k + 1
				}
				if (this.multipleSelection.length == k) {
					this.$message.success('批量处理完成')
					this.pages.page = 1
					this.getWarningListApi()
					this.dialogChuli = false
					this.chuliPage.T_Text = ''
				}
			}
		},
		setDevicEditApi(obj) {
			return new Promise(resolve => {
				DevicEdit(obj).then(res => {
					resolve(res)
				})
			})
		},
		selectChang() { //切换查询条件select
			this.getWarningListApi()
		},
		TimeChang(e) { //选择完时间确定按钮
			if (e) {
				this.pages.Time_start = e[0]
				this.pages.Time_end = e[1]
			} else {
				this.setTimefn()
			}
			this.getWarningListApi()
		},
		onSubmit() { //搜索按钮
			this.pages.page = 1
			this.getWarningListApi()
			this.drawer = false
		},
		handleSizeChange(e) { //每页多少条
			////console.log('每页多少条', e)
			this.pages.page_z = e
			this.getWarningListApi()
		},
		handleCurrentChange(e) { //跳转页
			////console.log('跳转页', e)
			this.pages.page = e
			this.getWarningListApi()
		},


		// toggleSelection(rows) {
		// 	if (rows) {
		// 		rows.forEach(row => {
		// 			this.$refs.multipleTable.toggleRowSelection(row);
		// 		});
		// 	} else {
		// 		this.$refs.multipleTable.clearSelection();
		// 	}
		// },
		handleSelectionChange(val) {
			this.multipleSelection = val;
		},
		inputValue(e) {
			this.pages.T_name = e
			this.pages.page = 1
			this.getWarningListApi()
		},
	}
}
</script>
<style lang="scss">
.el-table .warning-row {
	background: oldlace;
}

.callthepolice {
	.callthepolice-T {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: rgba(#fff, 1);
		height: 70px;
		padding: 15px 10px;
		box-shadow: 5px 5px 10px -10px #000;

		.callthepoliceL {
			display: flex;
			align-items: center;

			.RightsManagement-searchs {
				display: flex;
				align-items: center;
				justify-content: center;
				margin-left: 20px;

				.callthepoliceit-mai1-btn {}

				.RightsManagement-searchs1 {
					display: flex;
					align-items: center;
					justify-content: center;
				}
			}
		}

		.RightsManagement-searchsMai {
			display: flex;
			align-items: center;
			cursor: pointer;
		}
	}

	.callthepolice-B {
		background: rgba(#fff, 1);
		margin: 10px;
		padding: 20px 30px;
	}
}
</style>
